/* istanbul ignore next */
import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { MENU_PLP_CONSTANT, ENERGY_KJ, VIEW_UP } from '../NutritionAllergenConstants/NutritionAllergenConstants';
import { renderItemList, searchModeElmnt } from '../NutritionAllergenUtilities/NutritionAllergenSharedUtils';
import { Col } from 'reactstrap';
import NutrationAllergenItemList from './NutritionAllergenItemList';
import { changeMenulistOrder } from '../NutritionAllergenUtilities/NutritionAllergenUtils';

const {
  CARD_TYPE: { SMALL, CAROUSAL },
} = MENU_PLP_CONSTANT;
const renderItemListItems = (
  productsList,
  cardId,
  cType,
  subCategories,
  tenantData,
  catalogs,
  storeClosedData,
  selectedCat,
  getCardCount,
  viewUp,
) => {
  if (cType === VIEW_UP) {
    cType = viewUp ? SMALL : CAROUSAL;
  }
  return renderItemList(
    productsList,
    cardId,
    cType,
    tenantData,
    catalogs,
    storeClosedData,
    selectedCat,
    getCardCount,
    subCategories,
  );
};

const getClassForSearchMenuItem = () => {
  return 'sopac-medium-nutritionAllergen-container';
};
const desktopMenuItems = (
  dname,
  index,
  specials,
  discount,
  exclusive,
  timer,
  id,
  products,
  subCategories,
  tenantData,
  catalogs,
  storeClosedData,
  selectedCat,
  getCardCount,
  viewUp,
) => {
  return (
    <div>
      <div className='medium-category-name'>
        <h2>{dname[0]?.value}</h2>
      </div>
      <div className='energy-kj-title'>
        <div className='flex-end'>{translateWithI18Next(ENERGY_KJ)}</div>
      </div>
      {index === 0
        ? renderItemListItems(
            products,
            id,
            'large',
            subCategories,
            tenantData,
            catalogs,
            storeClosedData,
            selectedCat,
            getCardCount,
            viewUp,
          )
        : renderItemListItems(
            products,
            id,
            'medium',
            subCategories,
            tenantData,
            catalogs,
            storeClosedData,
            selectedCat,
            getCardCount,
            viewUp,
          )}
    </div>
  );
};

const getClassName = (localized, isSmartBannerVisible, index) => {
  if (localized && document?.getElementById('select-start-order-items')?.clientHeight > 40) {
    if (index === 0) {
      return 'offsetFirstIndex';
    }
    if (!isSmartBannerVisible && index === 0) {
      return 'offsetFirstIndexWithBanner';
    } else {
      return 'offsetOtherIndex';
    }
  } else if (localized) {
    return 'offsetWithLocalized';
  } else if (!isSmartBannerVisible && index === 0) {
    return 'offsetFirstIndexWithBanner';
  }
};
const mobileMenuItems = (
  products,
  index,
  dname,
  id,
  subCategories,
  viewUp,
  changeViewtoUp,
  viewCarousal,
  changeViewtoCarousal,
  carouselCount,
  tenantData,
  storeClosedData,
  catalogs,
  selectedCat,
  getCardCount,
  localized,
  isSmartBannerVisible,
) => {
  return (
    <>
      <div className={getClassName(localized, isSmartBannerVisible, index)}>
        <div className='d-flex position-relative padding-mobile'>
          <div className='small-category-name'>{dname[0].value}</div>
        </div>
        <div className='energy-kj-title'>
          <div className='flex-end'>{translateWithI18Next(ENERGY_KJ)}</div>
        </div>
        {renderItemListItems(
          products,
          id,
          'viewup',
          subCategories,
          tenantData,
          catalogs,
          storeClosedData,
          selectedCat,
          getCardCount,
          viewUp,
        )}
      </div>
    </>
  );
};
const OnSerchElmnt = (
  searchMode,
  filterList,
  dietaryList,
  products,
  isMobile,
  viewUp,
  tenantData,
  getCardCount,
  catalogs,
  storeClosedData,
  clearSearch,
  recommendProducts,
  carouselCount,
) => {
  if (searchMode.isSearchedMode && products?.length) {
    return (
      <div className={isMobile ? 'sopac-small-nutrition-container' : getClassForSearchMenuItem()}>
        <NutrationAllergenItemList
          productList={products}
          tenantData={tenantData}
          cardType={isMobile ? (viewUp && 'small') || 'carousal' : 'medium'}
          categoryId={''}
          cardCount={isMobile && getCardCount}
          storeClosedData={storeClosedData}
          catalogs={catalogs}
        />
      </div>
    );
  } else {
    return searchMode.isSearchedMode && searchModeElmnt(searchMode, clearSearch, isMobile);
  }
};
const getClass = (isMobile, index, viewCarousal) => {
  return isMobile ? 'sopac-small-nutrition-container' : 'sopac-medium-nutritionAllergen-container';
};

const NutritionAllergenItems = ({
  isMobile,
  searchMode,
  categories,
  viewCarousal,
  viewUp,
  changeViewtoUp,
  changeViewtoCarousal,
  carouselCount,
  tenantData,
  catalogs,
  storeClosedData,
  selectedCat,
  getCardCount,
  filterList,
  dietaryList,
  products,
  clearSearch,
  recommendProducts,
  localized,
}) => {
  const updatedCategories = categories?.length && changeMenulistOrder(categories);

  return (
    <Col className={isMobile ? 'mob-plp-col no-padding' : ''}>
      {!searchMode?.isSearchedMode && updatedCategories?.length
        ? updatedCategories
            ?.filter(({ isHidden }) => !isHidden)
            .map(
              (
                {
                  id,
                  name,
                  dname,
                  imageName,
                  products,
                  categories,
                  isHidden,
                  displayOrder,
                  specials,
                  exclusive,
                  timer,
                  discount,
                },
                index,
              ) => {
                return (
                  !isHidden && (
                    <div id={name?.trim()} className={getClass(isMobile, index, viewCarousal)} key={index}>
                      {isMobile
                        ? mobileMenuItems(
                            products,
                            index,
                            dname,
                            id,
                            categories,
                            viewUp,
                            changeViewtoUp,
                            viewCarousal,
                            changeViewtoCarousal,
                            carouselCount,
                            tenantData,
                            storeClosedData,
                            catalogs,
                            selectedCat,
                            getCardCount,
                            localized,
                            isMobile,
                          )
                        : desktopMenuItems(
                            dname,
                            index,
                            specials,
                            discount,
                            exclusive,
                            timer,
                            id,
                            products,
                            categories,
                            tenantData,
                            catalogs,
                            storeClosedData,
                            selectedCat,
                            getCardCount,
                            viewUp,
                          )}
                    </div>
                  )
                );
              },
            )
        : OnSerchElmnt(
            searchMode,
            filterList,
            dietaryList,
            products,
            isMobile,
            viewUp,
            tenantData,
            getCardCount,
            catalogs,
            storeClosedData,
            clearSearch,
            recommendProducts,
            carouselCount,
          )}
    </Col>
  );
};

export default React.memo(NutritionAllergenItems);
